const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');
const ensureTrailingSlash = (value = '') => `${trimTrailingSlash(value)}/`;

const WEB_HOST = trimTrailingSlash(
    process.env.VUE_APP_WEB_URL || 'https://xhexam.wxstores.com'
);
const WEB_URL = ensureTrailingSlash(WEB_HOST);
const admin_api = trimTrailingSlash(
    process.env.VUE_APP_ADMIN_API || `${WEB_HOST}/api`
);
const IMG_URL = ensureTrailingSlash(
    process.env.VUE_APP_IMG_URL || 'https://imgs.zzszjedu.cn'
);
const CERT_QUERY_PAGE_URL = trimTrailingSlash(
    process.env.VUE_APP_CERT_QUERY_PAGE_URL || `${WEB_HOST}/query/cert`
);
const CERT_API_URL = trimTrailingSlash(
    process.env.VUE_APP_CERT_API_URL || 'https://www.yktexam.cn/api'
);
const STUDY_URL = trimTrailingSlash(
    process.env.VUE_APP_STUDY_URL || 'https://www.yktexam.cn'
);
const EXAM_URL = trimTrailingSlash(
    process.env.VUE_APP_EXAM_URL || 'https://www.yktexam.cn'
);
const SITE_BG_URL =
    process.env.VUE_APP_SITE_BG_URL || `${WEB_URL}images/topbg.png`;
const DEFAULT_LOGO_URL =
    process.env.VUE_APP_DEFAULT_LOGO_URL || `${WEB_URL}images/grey_logo.jpg`;
const HOME_BANNER_URL =
    process.env.VUE_APP_HOME_BANNER_URL ||
    'http://www.hnzcpg.org.cn/sitesources/zcpgxh/theme/uxtheme10003/images/newsyhf.jpg';
const MOBILE_SITE_URL = trimTrailingSlash(
    process.env.VUE_APP_MOBILE_SITE_URL || 'http://api.yitku.cn/pch5'
);
const LEFT_QR_IMAGES = [
    process.env.VUE_APP_LEFT_QR_1 || 'http://api.yitku.cn/images/left_1.jpg',
    process.env.VUE_APP_LEFT_QR_2 || 'http://api.yitku.cn/images/left_2.png',
    process.env.VUE_APP_LEFT_QR_3 || 'http://api.yitku.cn/images/left_3.jpg',
    process.env.VUE_APP_LEFT_QR_4 || 'http://api.yitku.cn/images/left_4.jpg',
];

const buildCertQueryUrl = ({ tags = '', idCard = '', certNo = '' } = {}) => {
    const params = new URLSearchParams({
        tags,
        type: 'cert',
        idCard,
        certNo,
    });

    return `${CERT_QUERY_PAGE_URL}?${params.toString()}`;
};

const buildCertApiUrl = (path = '') =>
    `${CERT_API_URL}/${String(path).replace(/^\/+/, '')}`;

export default {
    admin_api,
    WEB_URL,
    IMG_URL,
    CERT_QUERY_PAGE_URL,
    CERT_API_URL,
    STUDY_URL,
    EXAM_URL,
    SITE_BG_URL,
    DEFAULT_LOGO_URL,
    HOME_BANNER_URL,
    MOBILE_SITE_URL,
    LEFT_QR_IMAGES,
    buildCertQueryUrl,
    buildCertApiUrl,
};
